const COUNTRY_CODE = '+1';

export const unmaskPhone = (value: string) => {
  return value.replace(COUNTRY_CODE, '').replace(/\D/g, '');
};

export const formatPhone = (value: string) => {
  const unmasked = unmaskPhone(value);
  let formatted = '';

  if (unmasked.length > 0) {
    formatted += '(' + unmasked.substring(0, 3);
  }
  if (unmasked.length >= 4) {
    formatted += ') ' + unmasked.substring(3, 6);
  }
  if (unmasked.length >= 7) {
    formatted += '-' + unmasked.substring(6, 10);
  }

  return formatted;
};
